<template></template>

<script type="text/javascript">

	import ReactiveVueObject from 'js/vue-support/reactive-vue-object.js';
	import GUIDFactory from 'js/common/identification/guid-factory';
	
	export default {
		$pubsub:{
			reactiveReferences:{
				namespace(){
					return this.namespace;
				},
				subscriptions:{
					addReference(object){
						const internalReference = GUIDFactory.generateGUID('RRF');
						this.reactiveReferences[internalReference] = object;
						this.mapOfObjectsToReferenceKeys.set(object, internalReference);
					}
				}
			}
		},
		props:{
			namespace:{
				required: true,
				type: String,
			}
		},
		data(){
			return {
				reactiveReferences: new ReactiveVueObject(),
			}
		},
		created(){
			this.mapOfObjectsToReferenceKeys = new WeakMap();
		}
	}
</script>